<template>
    <v-layout column>
      <v-card
        :style="cardStyle"
        flat
        class="intro-dark align-center justify-center mx-5">
        <v-card-title class="justify-center prompt-header py-3">
          <mrx-translation :token="prompt"></mrx-translation>
        </v-card-title>
        <v-card-text 
          class="px-0 overflow-auto" 
          ref="cardTextEl" 
          @scroll="onScroll"
        >
          <scroll-arrow
            id="preference-scroll-arrow"
            :show="hasOverflow" 
            :style="overlayStyle" 
            :arrowAlignment="arrowAlignment"
            v-on:scrollDown="instantScroll('down')"
            v-on:scrollUp="instantScroll('up')"
          ></scroll-arrow>
          <component
            class="pa-0"
            v-model="responses"
            :is="panel.input"
            :options="panel.options"
            :panelName="panel.name"
            :panelType="panel.type"
            :disabled="panel.options.disabled || false"
            style="flex: 1 1 100%; width: 100%;"
          >
          </component>
        </v-card-text>
      </v-card>
    </v-layout>
</template>

<script>
  import GeoLocation from '@/components/inputs/GeoLocation'
  import TextInput from '@/components/inputs/TextInput'
  import MultiSelect from '@/components/inputs/MultiSelect'
  import ScrollArrow from '../layouts/ScrollArrow.vue'
  import Markdown from '@/components/inputs/Markdown'
  import Terms from '@/components/inputs/Terms'
  import ui from '@/mixins/ui'
  import scrollArrow from '@/mixins/scrollArrow'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [ ui, scrollArrow ],
    components: { 
      geolocation: GeoLocation, 
      textinput: TextInput,
      multiselect: MultiSelect,
      markdown: Markdown,
      terms: Terms,
      ScrollArrow
    },
    name: 'Preference',
    data() {
      return {
        collections: null,
        title: null,
        nextLink: null   
      }
    },
    props: {
      maxHeightOffset: {
          type: Number,
          default: 0
        },
      initialMaxHeightOffset: {
        type: Number,
        default: 0
      }
    },
    computed: {
      prompt() {
        let token = `questions.${this.panel.name}.${this.promptType}`
        return this.$te(token, this.$i18n.fallbackLocale) ?
          token :
          `questions.${this.panel.name}.prompt`
      },
      responses() {
        let responses = this.panel.responses
        let result
        try {
          if (this.panel.actions && this.panel.actions.filterResponses && !this.mode('dontFilterResponses')) {
            let selectedResponses = responses.filter(x => x.selected)
            let filteredResponses = this[this.panel.actions.filterResponses](responses)
            let filteredResponseIds = filteredResponses.map(x => x.id)
            selectedResponses.forEach(r => {
              filteredResponseIds.includes(r.id) ? r.selected = true : r.selected = false
            })
            result = filteredResponses
          }
        }
        catch (e) {}

        return result || responses
      },
      panel() {
        return this.$route.meta.collection === 'preference' ? this.preference : this.pan
      },
      cardStyle() {
        return {
          display: 'flex',
          flexDirection: 'column',
          maxHeight: 'calc(100vh - ' + this.initialMaxHeightOffset + 'px)'
        }
      },
      ...mapGetters({
        pan: 'v4/panel/current',
        preference: 'v4/preference/current',
        track: 'v4/track/current',
        mode: 'v4/mode/get',
        promptType: 'v4/track/promptType'
      })
    },
    updated() {
      this.$nextTick(function() {
        if (this.$route.params.offset) {
          window.scroll(0, this.$route.params.offset)
        }
      })
    },
    mounted() {
      this.observedElement = this.$refs.cardTextEl
      this.observeForOverflow()
    },
  }
</script>

<style scoped>
  .prompt-header {
      font-weight: 600;
      font-size: 18px;
      line-height: 1.1em;
    }
</style>
